import notEmptyAttribute from '@model/_shared/validator/notEmptyAttribute'

export const validators = {
  type: notEmptyAttribute,
}

export {
  validators as default,
  notEmptyAttribute,
}
